module.exports = __webpack_public_path__ + "static/media/EN.9c18d558.svg";